import React from 'react'
import { Wrapper, WrapperUL, WrapperLi } from "./LeadFormSteps.styled";
import { BsInfoCircleFill } from "react-icons/bs";
import { FaSearchLocation, FaHome } from "react-icons/fa";
import { RiCheckDoubleLine } from "react-icons/ri";

const LeadFormSteps = ({ label }) => {
    const labels = { hm: 1, lo: 2, ad: 3, ap: 4 }
    const labelList = [
        { name: 'Homeowner', icon: <FaHome size={20} />, rank: 1 },
        { name: 'Location', icon: <FaSearchLocation size={20} />, rank: 2 },
        { name: 'Additional Info', icon: <BsInfoCircleFill size={20} />, rank: 3 },
        { name: 'Appointment', icon: <RiCheckDoubleLine size={20} />, rank: 4 },
    ];
    const step = labels[`${label}`.toLocaleLowerCase()] || 1;

    return (
        <Wrapper>
            <WrapperUL>
                {labelList.map((lab) => (
                    <WrapperLi active={lab.rank <= step}>
                        <div className='circle'>
                            {lab.rank <= step && lab.rank !== labels[label] ? <div className='checkmark'></div> : <div class="dot"></div>}
                        </div>
                        <div className='title'>
                            <div className="icon">{lab.icon}</div>
                            <div className="name">{lab.name}</div>
                        </div>
                    </WrapperLi>
                ))}
            </WrapperUL>
        </Wrapper>
    )
}

export default LeadFormSteps
